export default {
    learningPath: null,
    aggregatePath: null,
}
